<template>
    <form
        @submit.prevent="updatePassword"
        :action="url"
        method="post"
        class="card space-y-4 border-2 border-sky-500"
    >
        <h2 class="heading-2">Update Password</h2>

        <text-input
            type="password"
            label="Current Password"
            placeholder="Current Password"
            name="current_password"
            v-model="form.current_password"
            :error="form.errors.current_password"
        />
        <text-input
            type="password"
            placeholder="New Password"
            label="New Password"
            name="new_password"
            v-model="form.password"
            :error="form.errors.password"
        />

        <text-input
            type="password"
            label="Confirm Password"
            placeholder="New Password"
            name="password_confirmation"
            v-model="form.password_confirmation"
            :error="form.errors.password_confirmation"
        />

        <div class="flex justify-end items-center space-x-4">
            <transition
            enter-from-class="opacity-0"
            enter-active-class="transition-opacity ease-in duration-200"
            enter-to-class="opacity-100"
            leave-from-class="opacity-100"
            leave-active-class="transition-opacity ease-out duration-200"
            leave-to-class="opacity-0"
            >
                <div
                    v-if="form.recentlySuccessful"
                    class="text-gray-500"
                >
                    Saved.
                </div>
            </transition>
            <loading-button
                :loading="form.processing"
                type="submit"
                class="btn btn-green"
            >
                Change
            </loading-button>
        </div>

    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'

const props = defineProps({
    url: {
        type: String,
        required: true,
    }
})
const form = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
})

const updatePassword = () => {
    form.put(props.url, {
        onSuccess: () => form.reset()
    })
}
</script>
